"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _dropDown = _interopRequireDefault(require("@clayui/drop-down"));
var _shared = require("@clayui/shared");
var _classnames = _interopRequireDefault(require("classnames"));
var _fuzzy = _interopRequireDefault(require("fuzzy"));
var _react = _interopRequireWildcard(require("react"));
var _Context = require("./Context");
var _excluded = ["children", "className", "disabled", "innerRef", "keyValue", "match", "textValue", "value"],
  _excluded2 = ["children", "innerRef", "match", "value"],
  _excluded3 = ["children", "match"];
/**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var optionsFuzzy = {
  post: '|}',
  pre: '}|'
};
var NewItem = /*#__PURE__*/_react.default.forwardRef(function NewItem(_ref, ref) {
  var _ref2;
  var children = _ref.children,
    className = _ref.className,
    disabled = _ref.disabled,
    innerRef = _ref.innerRef,
    keyValue = _ref.keyValue,
    _ref$match = _ref.match,
    match = _ref$match === void 0 ? '' : _ref$match,
    textValue = _ref.textValue,
    value = _ref.value,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useAutocompleteState = (0, _Context.useAutocompleteState)(),
    activeDescendant = _useAutocompleteState.activeDescendant,
    onActiveDescendant = _useAutocompleteState.onActiveDescendant;
  var _useInteractionFocus = (0, _shared.useInteractionFocus)(),
    isFocusVisible = _useInteractionFocus.isFocusVisible;
  var isFocus = isFocusVisible();
  var hoverProps = (0, _shared.useHover)({
    disabled: disabled,
    onHover: (0, _react.useCallback)(function () {
      return !isFocus && onActiveDescendant(keyValue);
    }, [keyValue, isFocus])
  });
  var currentValue = (_ref2 = textValue !== null && textValue !== void 0 ? textValue : value) !== null && _ref2 !== void 0 ? _ref2 : String(children);
  var fuzzyMatch = _fuzzy.default.match(match, currentValue, optionsFuzzy);
  return /*#__PURE__*/_react.default.createElement(_dropDown.default.Item, _extends({}, otherProps, hoverProps, {
    "aria-selected": activeDescendant === keyValue,
    className: (0, _classnames.default)(className, {
      focus: activeDescendant === keyValue && isFocus,
      hover: activeDescendant === keyValue && !isFocus
    }),
    id: String(keyValue),
    innerRef: innerRef,
    ref: ref,
    tabIndex: -1
  }), match && fuzzyMatch && typeof children === 'string' ? fuzzyMatch.rendered.split('|').map(function (item, index) {
    var Text = item.includes('}') ? 'span' : 'strong';
    var value = item.replace(/\}/g, '');
    return value ? /*#__PURE__*/_react.default.createElement(Text, {
      className: !item.includes('}') ? 'mark' : undefined,
      key: index
    }, value) : null;
  }).filter(Boolean) : children !== null && children !== void 0 ? children : currentValue);
});
var ItemLegacy = /*#__PURE__*/_react.default.forwardRef(function ItemLegacy(_ref3, ref) {
  var children = _ref3.children,
    innerRef = _ref3.innerRef,
    _ref3$match = _ref3.match,
    match = _ref3$match === void 0 ? '' : _ref3$match,
    value = _ref3.value,
    otherProps = _objectWithoutProperties(_ref3, _excluded2);
  var currentValue = value !== null && value !== void 0 ? value : String(children);
  var fuzzyMatch = _fuzzy.default.match(match, currentValue, optionsFuzzy);
  return /*#__PURE__*/_react.default.createElement(_dropDown.default.Item, _extends({}, otherProps, {
    innerRef: innerRef,
    ref: ref
  }), match && fuzzyMatch ? fuzzyMatch.rendered.split('|').map(function (item, index) {
    var Text = item.includes('}') ? 'span' : 'strong';
    var value = item.replace(/\}/g, '');
    return value ? /*#__PURE__*/_react.default.createElement(Text, {
      key: index
    }, value) : null;
  }).filter(Boolean) : currentValue);
});
var Item = /*#__PURE__*/_react.default.forwardRef(function (_ref4, ref) {
  var children = _ref4.children,
    _ref4$match = _ref4.match,
    match = _ref4$match === void 0 ? '' : _ref4$match,
    otherProps = _objectWithoutProperties(_ref4, _excluded3);
  var _useAutocompleteState2 = (0, _Context.useAutocompleteState)(),
    onActiveDescendant = _useAutocompleteState2.onActiveDescendant;
  var Component = onActiveDescendant ? NewItem : ItemLegacy;
  return /*#__PURE__*/_react.default.createElement(Component, _extends({
    match: match
  }, otherProps, {
    ref: ref
  }), children);
});
Item.displayName = 'Item';
var _default = exports.default = Item;